import script from "./media-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./media-modal.vue?vue&type=script&setup=true&lang=js"

import "./media-modal.vue?vue&type=style&index=0&id=6c824cc2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c824cc2"]])

export default __exports__